import React from "react";
import Myhero2 from "../Myhero2/Myhero2";
import './Home.css'

const Home = () => {
  return (
    <div className="">
      <Myhero2/>
    </div>
  );
};

export default Home;
